import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class ArtJewelryType extends Enum {
  static ART = {
    key: 'art',
    get value() {
      return Lang.t('asset.art');
    }
  };

  static JEWELRY = {
    key: 'jewelry',
    get value() {
      return Lang.t('asset.jewelry');
    }
  };

  static COLLECTION = {
    key: 'collection',
    get value() {
      return Lang.t('asset.collection');
    }
  };

  static OTHER = {
    key: 'other',
    get value() {
      return Lang.t('asset.other');
    }
  };
}
